<div class="row baner-superior justify-content-center  m-0">
  <div class="col-6">
    <h1 style="color: #132069; margin-top: 70px; font-size: 3.5rem;">Gracias por tu reservación</h1>
  </div>
  <div class="col-4" style="text-align: end;">
    <img src="assets/imagenes/logo_horizontal.png" alt="Tecnopista" class="logoClass">
  </div>
</div>
<app-client-footer></app-client-footer>
